
// export const myGetter = ( state ) => {
//  return state
// }

export const placesList = state => state.places
export const placesSelectable = state => state.placesSelectable
export const placesPaginatedData = state => state.placesPaginatedData
export const place = state => state.place
export const isLoading = state => state.isLoading
export const isCreating = state => state.isCreating
export const isUpdating = state => state.isUpdating
export const createdData = state => state.createdData
export const updatedData = state => state.updatedData
export const isDeleting = state => state.isDeleting
export const deletedData = state => state.deletedData